import { getImageProps, ImageProps } from 'next/image';
import { useMemo } from 'react';

export type ArtDirectionImageProps = {
  className?: string;
  containerClassName?: string;
  imageProps: Array<
    Pick<
      ImageProps,
      'width' | 'height' | 'src' | 'sizes' | 'quality' | 'priority'
    > & {
      media: string;
    }
  >;
  alt: string;
};

export const ArtDirectionImage = ({
  imageProps,
  containerClassName,
  className,
  alt,
}: ArtDirectionImageProps) => {
  const propsArray = useMemo(() => {
    return imageProps.map((props) => {
      return getImageProps({ ...props, alt });
    });
  }, [imageProps, alt]);

  const lastProps = propsArray[imageProps.length - 1].props;

  return (
    <picture className={containerClassName}>
      {propsArray.map(({ props }, index) => {
        return (
          <source
            key={index}
            media={imageProps[index].media}
            srcSet={props.srcSet}
          />
        );
      })}
      <img {...lastProps} alt={lastProps.alt} className={className} />
    </picture>
  );
};
